import React from 'react';
import { X, CheckCircle2 } from 'lucide-react'; // משתמשים באייקונים הקיימים בפרויקט

const AddToCartPopup = ({ item, onClose, onContinueShopping, onProceedToCheckout }) => {

    // פונקציית עזר לתצוגת מחיר נקייה (מונעת כפילות של סמל השקל או טקסט שבור)
    const displayPrice = () => {
        if (!item.price) return 'ייקבע בייעוץ';
        if (item.price === 'בהתאמה אישית') return 'ייקבע בייעוץ';
        return item.price;
    };

    return (
        <div
            className="fixed inset-0 bg-black/60 backdrop-blur-sm flex justify-center items-center z-[100] transition-all duration-300 p-4"
            onClick={onClose}
            dir="rtl"
        >
            <div
                className="bg-surface p-6 sm:p-8 rounded-2xl w-full max-w-lg shadow-2xl transform transition-all duration-300 border border-secondary/50 relative"
                onClick={(e) => e.stopPropagation()}
            >
                {/* כפתור סגירה נקי (Lucide Icon) בפינה השמאלית עליונה */}
                <button
                    className="absolute top-4 left-4 p-2 text-text-muted hover:text-text-primary hover:bg-secondary/30 rounded-full transition-colors focus:outline-none"
                    onClick={onClose}
                    aria-label="סגור פופאפ"
                >
                    <X className="w-6 h-6" />
                </button>

                {/* כותרת - מדברת בשפת "פרויקט" ולא "סופרמרקט" */}
                <div className="flex items-center gap-3 mb-8 border-b border-secondary pb-4">
                    <CheckCircle2 className="w-8 h-8 text-primary" />
                    <h2 className="text-xl sm:text-2xl font-medium text-text-primary">
                        הפריט נוסף לסל הפרויקטים
                    </h2>
                </div>

                {/* פרטי הפריט */}
                <div className="flex flex-col sm:flex-row gap-6 mb-8 items-start bg-background p-4 rounded-xl border border-secondary-dark/30">
                    <img
                        src={item.image}
                        alt={item.title}
                        className="w-24 h-24 sm:w-32 sm:h-32 rounded-lg object-cover shadow-sm border border-secondary"
                    />
                    <div className="text-right space-y-2.5 flex-1">
                        <h3 className="text-lg font-medium text-text-primary mb-1 border-r-4 border-accent pr-2">{item.title}</h3>
                        <p className="text-sm text-text-secondary"><strong className="text-text-primary font-medium">מידות:</strong> {item.size}</p>

                        <div className="flex items-center gap-2 text-sm text-text-secondary">
                            <strong className="text-text-primary font-medium">גוון/צבע:</strong>
                            <span>{item.color?.name || 'ללא'}</span>
                            {item.color?.code && item.color.code !== 'none' && (
                                <span className="w-3.5 h-3.5 rounded-full border border-secondary shadow-sm block" style={{ backgroundColor: item.color.code }} />
                            )}
                        </div>

                        <p className="text-sm text-text-secondary"><strong className="text-text-primary font-medium">סוג עץ:</strong> {item.woodType}</p>
                        <p className="text-sm text-text-secondary mt-2 pt-2 border-t border-secondary/50"><strong className="text-accent font-medium">מחיר צפוי:</strong> {displayPrice()}</p>
                    </div>
                </div>

                {/* כפתורי פעולה */}
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 mt-8">
                    {/* כפתור ראשי - מעבר לסיכום */}
                    <button
                        onClick={onProceedToCheckout}
                        className="w-full sm:flex-1 bg-primary text-white py-3.5 px-6 rounded-xl font-medium hover:bg-primary-light transition-colors shadow-soft focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                    >
                        מעבר לסל הפרויקטים
                    </button>

                    {/* כפתור משני - חזרה לקטלוג */}
                    <button
                        onClick={onContinueShopping}
                        className="w-full sm:flex-1 bg-surface text-primary border-2 border-primary py-3.5 px-6 rounded-xl font-medium hover:bg-primary/5 transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
                    >
                        חזרה לקטלוג
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddToCartPopup;